import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState, type ChangeEvent } from "react";
import type { TableColumn } from "../../commponents/table/types";
import { Eye, Pencil, Trash2 } from "lucide-react";

  

import Modal from "../../commponents/Modal";
import { createProject, deleteProjectById, editProject, getProject, getProjectById } from "../../api/projectApi";
import {  useNavigate } from "react-router-dom";
import DataTable from "../../commponents/table/DataTable";
import { requiredText, runFieldValidation, type FieldErrors } from "../../helpers/validation";
import { showConfirm, showError, showSuccess } from "../../utils/ alert";

interface Project {
  id: number;
  projectName: string;
  image: string | null;
  description: string;
  status: string;
}


export default function Project() {
 
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [projects, setProjects] = useState<Project[]>([]);

  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [projectName, setProjectName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [previewImage, setPreviewImage] = useState("");
  const [projectImage, setProjectImage] = useState<File | null>(null);
  const [errors, setErrors] = useState<FieldErrors>({});

  const naivgate = useNavigate()

  const columns: TableColumn<Project>[] = [
    {
      key: "projectName",
      title: "Project",
    },

    {
      key: "id",
      title: "Action",
      render: (row) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleDetail(row.id)}
            className="rounded-lg bg-blue-100 p-2 text-blue-600 hover:bg-blue-200">
            <Eye size={18} />
          </button>
          <button
            onClick={() => handleEdit(row.id)}
            className="rounded-lg bg-yellow-100 p-2 text-yellow-600 hover:bg-yellow-200">
            <Pencil size={18} />
          </button>

          <button
            onClick={() => handleDelete(row.id)}
            className="rounded-lg bg-red-100 p-2 text-red-600 hover:bg-red-200">
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];

  const fetchProject = async () => {
    try {
      setLoading(true);

      const response = await getProject({
        page: currentPage,
        limit: pageSize,
      });



      setProjects(response.data.projectStructureList);

      setTotalPages(response.data.pagination.totalPages);

      setTotalData(response.data.pagination.totalData);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProject();
  }, [currentPage, pageSize]);

  useEffect(() => {
  
  }, [Project]);

  const handleSave = async () => {
    try {
   const fieldErrors = runFieldValidation(
     {
       project_name: projectName,
       description,
     },
     {
       project_name: requiredText("Project name is required"),
       description: requiredText("Description is required"),
     }
   );

   setErrors(fieldErrors);

   if (Object.keys(fieldErrors).length > 0) {
     return;
   }

      const formData = new FormData();

      formData.append("project_name", projectName);
      formData.append("description", description);
      formData.append("status", "Active");

      if (image) {
        formData.append("image", image);
      }


      if (isEdit && selectedId !== null) {
        await editProject(selectedId, formData);

        await showSuccess("Project updated successfully.");
      } else {
        await createProject(formData);

        await showSuccess("Project created successfully.");
      }

      await fetchProject();

      handleCloseModal();
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
      showError("Failed to save project.");
    }
  };

  const handleEdit = async (id: number) => {
    try {
      const { data } = await getProjectById(id);

      setProjectName(data.data.project_name);
      setDescription(data.data.description)
      setProjectImage(data.data.image);
      setImage(data.data.image);
    
      setPreviewImage(data.data.image);
      setSelectedId(id);
      setIsEdit(true);
      setOpenModal(true);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    }
  };

  const handleDetail = async (id:number) => {
    naivgate(`/project/detail/${id}`);
  }

  const handleDelete = async (id: number) => {
    try {
      const confirmed = await showConfirm(
        "Delete Invoice",
        "Are you sure you want to delete this project?"
      );

      if (!confirmed) return;

      await deleteProjectById(id);

      await fetchProject();

      await showSuccess("Project deleted successfully.");

      // fetchProducts(); // refresh list
    } catch (error) {
      showError("Failed", "Failed to deleted data.");
    
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setProjectName("");
    setSelectedId(null);
    setIsEdit(false);
    setImage(null);
    setPreviewImage("");
    setDescription("");

  };

  const handleAdd = () => {
    setIsEdit(false);
    setSelectedId(null);
    setProjectName("");
    setOpenModal(true);
  };
const handleUploadImage = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];

  if (!file) return;

  setImage(file);
  setPreviewImage(URL.createObjectURL(file));
};
  
  const handleRemoveImage = () => {
    setImage(null);
    setPreviewImage("");
  };



  return (
    <AdminLayout>
      <div className="bg-white rounded-3xl p-6">
        <DataTable
          title="Project List"
          columns={columns}
          data={projects}
          onAdd={handleAdd}
          showSearch={false}
          showFilter={false}
          
          pagination={{
            currentPage,
            totalPages,
            pageSize,
            onPageChange: setCurrentPage,
            onPageSizeChange: (size) => {
              setPageSize(size);
              setCurrentPage(1);
            },
          }}
        />

        <Modal
          open={openModal}
          title={isEdit ? "Edit Project" : "Add Project"}
          onClose={handleCloseModal}
          size="xl">
          <div className="w-[920px] max-w-full p-2">
            <div className="grid grid-cols-2 gap-10">
              {/* LEFT */}
              <div className="space-y-6">
                <div>
                  <label className="mb-2 block text-base font-semibold">
                    Project Name
                  </label>

                  <input
                    type="text"
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                    placeholder="Type here"
                    className="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none focus:border-blue-500"
                  />
                </div>

                <div>
                  <label className="mb-2 block text-base font-semibold">
                    Description
                  </label>

                  <textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Type here"
                    rows={12}
                    className="h-[340px] w-full resize-none rounded-xl border border-gray-300 p-4 outline-none focus:border-blue-500"
                  />
                </div>
              </div>

              {/* RIGHT */}
              <div className="flex flex-col items-center">
                <div className="relative">
                  <div className="flex h-[340px] w-[340px] items-center justify-center overflow-hidden rounded-3xl bg-gray-100 border">
                    {previewImage ? (
                      <img
                        src={previewImage}
                        alt="preview"
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      <div className="text-center text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="mx-auto mb-3 h-16 w-16"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M4 16l4-4 4 4 4-6 4 6"
                          />
                        </svg>

                        <p>No Image</p>
                      </div>
                    )}
                  </div>

                  {previewImage && (
                    <button
                      onClick={handleRemoveImage}
                      className="absolute -right-3 -top-3 flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white shadow-lg hover:bg-red-700">
                      ✕
                    </button>
                  )}
                </div>

                <label
                  className="
            mt-8
            flex
            h-14
            w-[340px]
            cursor-pointer
            items-center
            justify-center
            rounded-xl
            border-2
            border-dashed
            border-gray-300
            text-green-600
            transition
            hover:bg-green-50
          ">
                  Upload Image
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleUploadImage}
                  />
                </label>
              </div>
            </div>

            {/* FOOTER */}

            <div className="mt-10 flex justify-end gap-4">
              <button
                onClick={handleCloseModal}
                className="rounded-xl bg-red-600 px-7 py-3 font-medium text-white hover:bg-red-700">
                Cancel
              </button>

              <button
                onClick={handleSave}
                className="rounded-xl bg-green-600 px-7 py-3 font-medium text-white hover:bg-green-700">
                {isEdit ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </AdminLayout>
  );
}
